/**
 * Utilities Tour Configuration
 *
 * Overview tour for the Utilities page. Only includes steps for elements
 * currently visible in the DOM.
 */

import { filterExistingSteps } from './tourUtils.js';

export const getUtilitiesTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="utilities-header"]',
      content: t('tour.utilities.header', {
        ns: 'common',
        defaultValue: 'Utilities Payment - Pay all your utility bills in one place. Support for electricity, water, internet, TV, and more.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-selection"]',
      content: t('tour.utilities.selection', {
        ns: 'common',
        defaultValue: 'Select a utility provider to get started. Additional fields appear as you verify account details.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-electricity"]',
      content: t('tour.utilities.electricity', {
        ns: 'common',
        defaultValue: 'Pay your electricity bills quickly and securely. Support for prepaid and postpaid meters.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-water"]',
      content: t('tour.utilities.water', {
        ns: 'common',
        defaultValue: 'Settle your water bills with ease. Enter your meter number and amount to pay.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-internet"]',
      content: t('tour.utilities.internet', {
        ns: 'common',
        defaultValue: 'Purchase internet data bundles for your mobile devices. Choose your network and bundle package.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-tv"]',
      content: t('tour.utilities.tv', {
        ns: 'common',
        defaultValue: 'Pay for cable TV subscriptions like DStv and GOtv. Select your provider and subscription package.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-phone"]',
      content: t('tour.utilities.phone', {
        ns: 'common',
        defaultValue: 'Top up airtime for any mobile network. Quick and convenient mobile money recharges.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="utilities-provider-broadband"]',
      content: t('tour.utilities.broadband', {
        ns: 'common',
        defaultValue: 'Pay for broadband subscriptions. Support for MTN and Telecel networks.',
      }),
      position: 'bottom',
    },
  ]);
